import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { Map, Set } from 'immutable';
import { filter, map, Observable } from 'rxjs';

import { DcCoreElementType } from '../dc-core-types';
import { CurrentUser } from '../domain/current-user';
import { MarketplaceMemberEntity } from '../domain/marketplace-member.entity';
import { ElementPermission } from '../domain/permission-types';
import { CoreOriginalSliceState, CoreSliceKey } from './app.state';
import { featureSelector, IAppRootState } from './feature.store';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[CoreSliceKey]
);

const CurrentUser = createSelector(baseSelector, (state) => state.currentUser);

const AvailableMarketplaceMembers = createSelector(
	baseSelector,
	(state) => state.availableMarketPlaceMembers.members
);

const TotalAvailableMarketplaceMembers = createSelector(
	baseSelector,
	(state) => state.availableMarketPlaceMembers.total
);

@Injectable({
	providedIn: 'root',
})
export class AppSelector {
	public constructor(private readonly store: Store<IAppRootState>) {}

	private get state(): Observable<CoreOriginalSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getAvailablePermissions$(): Observable<
		Map<DcCoreElementType, Set<ElementPermission>>
	> {
		return this.state.pipe(map((state) => state.get('availablePermissions')));
	}

	public getCurrentUser$(): Observable<CurrentUser> {
		return this.store.pipe(
			select(CurrentUser),
			filter((user): user is CurrentUser => user !== null)
		);
	}

	public getAvailableMarketplaceMembers$(): Observable<
		Map<string, MarketplaceMemberEntity>
	> {
		return this.store.pipe(select(AvailableMarketplaceMembers));
	}

	public getTotalAvailableMarketplaceMembers$(): Observable<number> {
		return this.store.pipe(select(TotalAvailableMarketplaceMembers));
	}
}
